import { render, staticRenderFns } from "./video-chapter-list.vue?vue&type=template&id=358944d8&scoped=true"
import script from "./video-chapter-list.vue?vue&type=script&lang=js"
export * from "./video-chapter-list.vue?vue&type=script&lang=js"
import style0 from "./video-chapter-list.vue?vue&type=style&index=0&id=358944d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358944d8",
  null
  
)

export default component.exports